<template>
    <div>

        <proforma-modal v-if="isAddEditModalActive" :table-id="tableId" :selected-url="selectedUrl"
            @close-modal="closeAddEditModal" />

        <app-table :id="tableId" :options="options" @action="getListAction" />

    </div>
</template>


<script>
    import CoreLibrary from "@/core/helpers/CoreLibrary.js";
    import * as actions from "../../../../apiUrl";
    import { TabApprovedHelpers } from "../helpers/TabApprovedHelpers";

    export default {
        extends: CoreLibrary,
        name: "TabApproved",
        mixins: [TabApprovedHelpers],
        data() {
            return {
                deleteLoader: false,
                isAddEditModalActive: false,
                deleteConfirmationModalActive: false,
                selectedUrl: "",
                tableId: "proforma-list",
                rowData: {},
                options: {
                    url: `${actions.ACCREDITATION_PROCESS}/quotation/proforma/203`,
                    name: this.$t("demo_crud"),
                    showHeader: true,
                    columns: [],
                    actions: [
                    {
                        title: this.$t("Revisar solicitud"),
                        icon: "eye",
                        type: "none",
                        component: "proforma-modal",
                        modalId: "proforma-review-modal",
                    },
                    ],
                    showFilter: false,
                    showSearch: false,
                    paginationType: "pagination",
                    responsive: true,
                    rowLimit: 10,
                    showAction: true,
                    orderBy: "desc",
                    actionType: "default",
                },
            };
        },
        created() {
            this.$hub.$on("reload-table", () => {
                this.$hub.$emit("reload-" + this.tableId);
            });
            this.options.columns = [...this.tableColumns, this.actionObj];
        },
        methods: {
            /**
             * for open add edit modal
             */
            openAddEditModal() {
                // console.log('hola');
                this.isAddEditModalActive = true;
            },

            /**
             * for close add edit modal
             */
            closeAddEditModal() {
                $("#proforma-review-modal").modal("hide");
                this.isAddEditModalActive = false;
                this.reSetData();
            },

            /**
             * $emit form datatable action
             */
            getListAction(rowData, actionObj, active) {
                this.rowData = rowData;
                this.selectedUrl = `${actions.ACCREDITATION_PROCESS}/quotation/${rowData.id}`;
                this.$store.dispatch("postEmailAccess",rowData.id);
                this.openAddEditModal();
            },

            /**
             * for open confirmation modal
             */
            openDeleteModal() {
                this.deleteConfirmationModalActive = true;
            },

            /**
             * confirmed $emit form confirmation modal
             */
            confirmed() {
                let url = `${actions.ACCREDITATION_PROCESS}/${this.rowData.id}`;
                this.deleteLoader = true;
                this.axiosDelete(url)
                    .then((response) => {
                    this.deleteLoader = false;
                    $("#pending-delete").modal("hide");
                    this.cancelled();
                    this.$toastr.s(response.data.message);
                    })
                    .catch(({ error }) => {
                    //trigger after error
                    })
                    .finally(() => {
                    this.$hub.$emit("reload-" + this.tableId);
                    });
            },

            /**
             * cancelled $emit form confirmation modal
             */
            cancelled() {
                this.deleteConfirmationModalActive = false;
                this.reSetData();
            },
            reSetData() {
                this.rowData = {};
                this.selectedUrl = "";
            }
        },
    };
</script>
